<button
  mat-icon-button
  [matMenuTriggerFor]="panel"
  (menuOpened)="onOpen()"
  [matBadge]="facade.unreadCount() > 0 ? facade.unreadCount() : undefined"
  matBadgeSize="small"
  matBadgeColor="warn"
  matTooltip="Notificaciones"
  aria-label="Notificaciones"
>
  <mat-icon svgIcon="bell"></mat-icon>
</button>

<mat-menu #panel="matMenu" class="w-80">
  <div class="flex items-center justify-between px-4 py-2">
    <span class="font-medium text-primary">Notificaciones</span>
    @if (facade.unreadCount() > 0) {
      <button mat-button (click)="markAllRead()">Marcar todas como leídas</button>
    }
  </div>

  <div class="max-h-96 overflow-y-auto">
    @if (facade.items().length === 0) {
      <div class="px-4 py-6 text-center text-small text-secondary">Sin notificaciones.</div>
    }

    @for (notification of facade.items(); track notification.id) {
      <button
        mat-menu-item
        class="!h-auto whitespace-normal py-2"
        [class.bg-surface-hover]="!notification.isRead"
        (click)="open(notification)"
      >
        <div class="flex items-start gap-2">
          @if (!notification.isRead) {
            <span class="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-brand" aria-hidden="true"></span>
          }
          <div>
            <div class="font-medium text-primary">{{ notification.title }}</div>
            <div class="text-small text-secondary">{{ notification.message }}</div>
          </div>
        </div>
      </button>
    }
  </div>
</mat-menu>
